import { AdaptiveAuthenticationReferenceData, AdaptiveAuthenticationSearchFiltersState } from "@idw-types/state/adaptive-authentication-state";
import { FormattedAdaptiveAuthenticationResult } from "@idw-types/data/adaptive-authentication-result/adaptive-authentication-result";

export enum AdaptiveAuthenticationActionTypes {
    // Reference Data
    SET_ADAPTIVE_AUTHENTICATION_REFERENCE_DATA_LOADING = "SET_ADAPTIVE_AUTHENTICATION_REFERENCE_DATA_LOADING",
    SET_ADAPTIVE_AUTHENTICATION_REFERENCE_DATA = "SET_ADAPTIVE_AUTHENTICATION_REFERENCE_DATA",
    // Search
    SET_ADAPTIVE_AUTHENTICATION_SEARCH_FILTERS = "SET_ADAPTIVE_AUTHENTICATION_SEARCH_FILTERS",
    SET_ADAPTIVE_AUTHENTICATION_SEARCH_RESULTS_LOADING = "SET_ADAPTIVE_AUTHENTICATION_SEARCH_RESULTS_LOADING",
    SET_ADAPTIVE_AUTHENTICATION_SEARCH_RESULTS = "SET_ADAPTIVE_AUTHENTICATION_SEARCH_RESULTS"
}

// Reference Data
type SetAdaptiveAuthenticationReferenceDataLoadingAction = {
    type: AdaptiveAuthenticationActionTypes.SET_ADAPTIVE_AUTHENTICATION_REFERENCE_DATA_LOADING,
    payload: { isLoading: boolean }
};

export const setAdaptiveAuthenticationReferenceDataLoading = (isLoading: boolean): SetAdaptiveAuthenticationReferenceDataLoadingAction => ({
    type: AdaptiveAuthenticationActionTypes.SET_ADAPTIVE_AUTHENTICATION_REFERENCE_DATA_LOADING,
    payload: { isLoading }
});

type SetAdaptiveAuthenticationReferenceDataAction = {
    type: AdaptiveAuthenticationActionTypes.SET_ADAPTIVE_AUTHENTICATION_REFERENCE_DATA,
    payload: { referenceData: AdaptiveAuthenticationReferenceData; }
};

export const setAdaptiveAuthenticationReferenceData = (referenceData: AdaptiveAuthenticationReferenceData): SetAdaptiveAuthenticationReferenceDataAction => ({
    type: AdaptiveAuthenticationActionTypes.SET_ADAPTIVE_AUTHENTICATION_REFERENCE_DATA,
    payload: { referenceData }
});

// Search
type SetAdaptiveAuthenticationSearchFiltersAction = {
    type: AdaptiveAuthenticationActionTypes.SET_ADAPTIVE_AUTHENTICATION_SEARCH_FILTERS;
    payload: { searchFilters: AdaptiveAuthenticationSearchFiltersState };
};

export const setAdaptiveAuthenticationSearchFilters = (searchFilters: AdaptiveAuthenticationSearchFiltersState): SetAdaptiveAuthenticationSearchFiltersAction => ({
    type: AdaptiveAuthenticationActionTypes.SET_ADAPTIVE_AUTHENTICATION_SEARCH_FILTERS,
    payload: { searchFilters }
});

type SetAdaptiveAuthenticationSearchResultsLoadingAction = {
    type: AdaptiveAuthenticationActionTypes.SET_ADAPTIVE_AUTHENTICATION_SEARCH_RESULTS_LOADING;
    payload: { isLoading: boolean };
};

export const setAdaptiveAuthenticationSearchResultsLoading = (
    isLoading: boolean
): SetAdaptiveAuthenticationSearchResultsLoadingAction => ({
    type: AdaptiveAuthenticationActionTypes.SET_ADAPTIVE_AUTHENTICATION_SEARCH_RESULTS_LOADING,
    payload: { isLoading }
});

type SetAdaptiveAuthenticationSearchResultsAction = {
    type: AdaptiveAuthenticationActionTypes.SET_ADAPTIVE_AUTHENTICATION_SEARCH_RESULTS;
    payload: { adaptiveAuthenticationResults: Array<FormattedAdaptiveAuthenticationResult> };
};

export const setAdaptiveAuthenticationSearchResults = (
    adaptiveAuthenticationResults: Array<FormattedAdaptiveAuthenticationResult>
): SetAdaptiveAuthenticationSearchResultsAction => ({
    type: AdaptiveAuthenticationActionTypes.SET_ADAPTIVE_AUTHENTICATION_SEARCH_RESULTS,
    payload: { adaptiveAuthenticationResults }
});

export type AdaptiveAuthenticationActions =
    // Reference Data
    SetAdaptiveAuthenticationReferenceDataLoadingAction |
    SetAdaptiveAuthenticationReferenceDataAction |
    // Search
    SetAdaptiveAuthenticationSearchFiltersAction |
    SetAdaptiveAuthenticationSearchResultsLoadingAction |
    SetAdaptiveAuthenticationSearchResultsAction